/** @typedef {'list' | 'grid'} DocumentsViewMode */

/** @type {DocumentsViewMode} */
export const DOCUMENTS_DEFAULT_VIEW = 'list'
